/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { externalKeysCreateGcpKms } from "../funcs/externalKeysCreateGcpKms.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GcpKmsKey } from "../models/components/gcpkmskey.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateGcpKmsKeyRequest,
  CreateGcpKmsKeySecurity,
} from "../models/operations/creategcpkmskey.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type CreateGcpKmsKeyMutationVariables = {
  request: CreateGcpKmsKeyRequest;
  security?: CreateGcpKmsKeySecurity | undefined;
  options?: RequestOptions;
};

export type CreateGcpKmsKeyMutationData = GcpKmsKey;

export type CreateGcpKmsKeyMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createGcpKmsKey externalKeys
 *
 * @remarks
 * Create a GCP KMS external key. Requires org:admin.
 */
export function useCreateGcpKmsKeyMutation(
  options?: MutationHookOptions<
    CreateGcpKmsKeyMutationData,
    CreateGcpKmsKeyMutationError,
    CreateGcpKmsKeyMutationVariables
  >,
): UseMutationResult<
  CreateGcpKmsKeyMutationData,
  CreateGcpKmsKeyMutationError,
  CreateGcpKmsKeyMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildCreateGcpKmsKeyMutation(client, options),
    ...options,
  });
}

export function mutationKeyCreateGcpKmsKey(): MutationKey {
  return ["@gram/client", "externalKeys", "createGcpKms"];
}

export function buildCreateGcpKmsKeyMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: CreateGcpKmsKeyMutationVariables,
  ) => Promise<CreateGcpKmsKeyMutationData>;
} {
  return {
    mutationKey: mutationKeyCreateGcpKmsKey(),
    mutationFn: function createGcpKmsKeyMutationFn({
      request,
      security,
      options,
    }): Promise<CreateGcpKmsKeyMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(externalKeysCreateGcpKms(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
